module.exports = __webpack_public_path__ + "img/nanook-logo.fd80e499.svg";